import { render, staticRenderFns } from "./VerifyCitizenID.vue?vue&type=template&id=4c63d7fa"
import script from "./VerifyCitizenID.vue?vue&type=script&lang=js"
export * from "./VerifyCitizenID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports